import React from 'react';
import { calculatorState as store, observer } from 'store';
import Tag from 'components/UI/Tag';

function Desktop({
  calculatorID,
  sectionName,
  items,
  getCounterValue,
  onChangeCount,
  defaultValue,
}) {
  const onChange = (item, value) => {
    store.clearSectionInfo(calculatorID, sectionName, defaultValue);
    onChangeCount(item, !value);
  };

  return (
    <>
      {items.map(item => {
        const value = getCounterValue(item);
        return (
          <Tag key={item} active={value} onClick={() => onChange(item, value)}>
            {item}
          </Tag>
        );
      })}
    </>
  );
}

export default observer(Desktop);
